import type { z } from 'zod';
import { ApiProblemError, WriteRefusedError, fetchJson, type ApiFetch } from './apiFetchJson';
import type { ApiFetchInit } from './api';

/**
 * `fetchJson`, with a non-2xx answered by `onHttp` instead of thrown as an
 * `ApiProblemError`. `onHttp` either returns a stand-in value (an empty list)
 * or throws the error the caller wants to surface (fixed copy, `AdminApiError`).
 * Network, aborted and malformed failures are not HTTP failures and always
 * pass through as the `ApiProblemError` they already are. So does a policy
 * refusal (`WriteRefusedError`): `apiFetch` has already announced it, and
 * re-wrapping it would toast it a second time under the caller's copy.
 */
export async function fetchJsonOnHttp<S extends z.ZodType, T>(
  apiFetch: ApiFetch,
  schema: S,
  input: string,
  init: ApiFetchInit | undefined,
  onHttp: (err: ApiProblemError) => T
): Promise<z.output<S> | T> {
  try {
    return await fetchJson(apiFetch, schema, input, init);
  } catch (err) {
    if (err instanceof ApiProblemError && err.kind === 'http' && !(err instanceof WriteRefusedError)) return onHttp(err);
    throw err;
  }
}
